module.exports = __webpack_public_path__ + "static/media/pl-rails.3eea0288.png";